import React, { useEffect, useState } from 'react'
import CRMLayout from '../../../../../../layout/components/CRMLayout'
import proposalServices from '../proposalServices';
import ProposalForm from '../component/ProposalForm';
import ProposalGrid from '../component/ProposalGrid';

function ProposalListPage() {
  const [proposalList,setProposalList] = useState(null);
  const [loading,setLoadingStatus] = useState(false)

  const getProposalList = () =>{
    setLoadingStatus(true);
    proposalServices.getList().then(res=>{
      setProposalList(res.data);
    }).catch(error=>{

    }).finally(()=>{
      setLoadingStatus(false);
    })
  }

  useEffect(()=>{
    getProposalList();
  },[])

  return (
    <CRMLayout>
      <div className='row'>
        <div className='col-md-12'>
          <span className='float-end'><ProposalForm callBack={getProposalList} /></span>
        </div>
      </div>

      <div className='row mt-2'>
        <div className='col-md-12'>
            <ProposalGrid proposalList={proposalList} />
        </div>
      </div>
      
    </CRMLayout>
  )
}

export default ProposalListPage